// extracted by mini-css-extract-plugin
export default {"title":"NotificationModal_title__Js5Ap","notification_modal":"NotificationModal_notification_modal__+c4b-"};